import axios from "axios";
const deployEnvironment = require("../../deployEnvironment.js");

const API = deployEnvironment;
const STORAGE_KEY = "accessToken";

class AssetsApi {
  // Items
  async getItems(fetchPath) {
    const accessToken = sessionStorage.getItem(STORAGE_KEY);

    const getItemsResponse = await axios.post(
      `${API}/api/spaces-api/list`,
      { prefix: fetchPath },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    const items = getItemsResponse.data.objects;

    return new Promise((resolve, reject) => {
      try {
        if (!items) {
          reject(new Error("Unauthorized"));
          return;
        }
        resolve(items);
      } catch (err) {
        reject(new Error("Internal server error"));
      }
    });
  }

  async createFolder(folderName) {
    const accessToken = sessionStorage.getItem(STORAGE_KEY);

    await axios.post(
      `${API}/api/spaces-api/createFolder`,
      { folderName },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
  }

  async viewItem(filePath) {
    const accessToken = sessionStorage.getItem(STORAGE_KEY);

    const res = await axios.post(
      `${API}/api/spaces-api/download`,
      { filePath },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    const url = res.data.url;

    return new Promise((resolve, reject) => {
      try {
        if (!url) {
          reject(new Error("Unauthorized"));
          return;
        }
        resolve(url);
      } catch (err) {
        reject(new Error("Internal server error"));
      }
    });
  }

  async deleteFolder(folderPath) {
    const accessToken = sessionStorage.getItem(STORAGE_KEY);

    await axios.post(
      `${API}/api/spaces-api/deleteFolder`,
      { folderPath },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
  }

  async deleteItem(filePath) {
    const accessToken = sessionStorage.getItem(STORAGE_KEY);

    await axios.post(
      `${API}/api/spaces-api/deleteItem`,
      { filePath },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
  }

  async deleteMultipleItems(filesPathArray) {
    const accessToken = sessionStorage.getItem(STORAGE_KEY);

    await axios.post(
      `${API}/api/spaces-api/deleteMultipleItems`,
      { filesPathArray },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
  }

  async uploadFiles(selectedFilesForUpload) {
    try {
      const accessToken = sessionStorage.getItem(STORAGE_KEY);

      const uploadFilesResponse = await axios.post(
        `${API}/api/spaces-api/upload`,
        selectedFilesForUpload,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      return uploadFilesResponse.data;
    } catch (err) {
      throw err.response.data;
    }
  }

  async exportExcelFiles(fetchPath) {
    const accessToken = sessionStorage.getItem(STORAGE_KEY);

    const getExportExcelFilesResponse = await axios.post(
      `${API}/api/spaces-api/export-excel`,
      { prefix: fetchPath },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    const getExportExcelFiles = getExportExcelFilesResponse.data;

    return new Promise((resolve, reject) => {
      try {
        if (!getExportExcelFiles) {
          reject(new Error("Unauthorized"));
          return;
        }

        resolve(getExportExcelFiles);
      } catch (err) {
        reject(new Error("Internal server error"));
      }
    });
  }

  async getSpacesApiHistory() {
    const accessToken = sessionStorage.getItem(STORAGE_KEY);

    const getSpacesApiHistoryResponse = await axios.get(
      `${API}/api/spaces-api/spaces-api-history`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    const getSpacesApiHistoryLogs = getSpacesApiHistoryResponse.data;

    return new Promise((resolve, reject) => {
      try {
        if (!getSpacesApiHistoryLogs) {
          reject(new Error("Unauthorized"));
          return;
        }
        resolve(getSpacesApiHistoryLogs);
      } catch (err) {
        reject(new Error("Internal server error"));
      }
    });
  }
}

export const assetsApi = new AssetsApi();
